import { Component, OnInit, TemplateRef } from '@angular/core';
import { RouteConsts } from 'src/app/common/route-consts';
import { JqHelper } from 'src/app/common/jq-helper';
import { UnitOfWorkService } from 'src/app/services/api/uow/unit-of-work.service';
import { LocalStorageService } from 'src/app/services/common/local-storage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-garage-settings',
  templateUrl: './garage-settings.component.html',
  styleUrls: ['./garage-settings.component.scss']
})
export class GarageSettingsComponent implements OnInit {
  public _routeConsts = new RouteConsts();
  modalRef: BsModalRef;
  currentUser: any = {};
  constructor(
    private _jq: JqHelper,
    private _uow: UnitOfWorkService,
    public _localService: LocalStorageService,
    private spinner: NgxSpinnerService
  ) {
    this.currentUser = this._uow.authenticationService.getUser();
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this._jq.initDataTable();

  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this._uow.modalServiceEx.show(template);
  }

  openDeleteModel(template: TemplateRef<any>) {
    this.openModal(template);

  }

  conformDelete() {
    this.spinner.show();
    this._uow.gSettingService.SyncItemWarehouseAsync().subscribe((res: any) => {
      this.spinner.hide();
      this.modalRef.hide();
      Swal.fire(
        'Sync!',
        'Item Sync',
        'success'
      );

    }, (err) => {
      // this._jq.showSpinner();
      this.spinner.hide();
    });
  }
}
